'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTracker = undefined;

var _client = require('./client');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTracker = exports.createTracker = _client2.default.createTracker;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker/static-1.108/js/index.js
// module id = 381
// module chunks = 0